'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ERROR_MODALS_MAP, _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _boardSelector = require('../../element/board/boardSelector');

var _errorModalSelector = require('./modals/errorModalSelector');

var _permissionsService = require('../../utils/permissions/permissionsService');

var _permissionUtil = require('../../../common/permissions/permissionUtil');

var _rollbarService = require('../../analytics/rollbarService');

var _navigationActions = require('../../reducers/navigationActions');

var _errorModalActions = require('./modals/errorModalActions');

var _currentBoardIdActions = require('../../reducers/currentBoardId/currentBoardIdActions');

var _ModalManager = require('../modal/ModalManager');

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _UnknownErrorModal = require('./modals/components/UnknownErrorModal');

var _UnknownErrorModal2 = _interopRequireDefault(_UnknownErrorModal);

var _BoardSimpleErrorModal = require('./modals/components/BoardSimpleErrorModal');

var _BoardSimpleErrorModal2 = _interopRequireDefault(_BoardSimpleErrorModal);

var _BoardAccessDeniedModal = require('./modals/components/BoardAccessDeniedModal');

var _BoardAccessDeniedModal2 = _interopRequireDefault(_BoardAccessDeniedModal);

var _TimeoutErrorModal = require('./modals/components/TimeoutErrorModal');

var _TimeoutErrorModal2 = _interopRequireDefault(_TimeoutErrorModal);

var _errorConstants = require('../../../common/error/errorConstants');

var _rollbarConstants = require('../../analytics/rollbarConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib


// Selectors


// Utils


// Actions


// Components


// Constants


var READ_PERMISSIONS = (0, _permissionUtil.calculatePermissionValue)({
    read: true,
    write: false,
    owner: false,
    permissions: false,
    save: false
});

var ERROR_MODALS_MAP = (_ERROR_MODALS_MAP = {
    // Unknown error
    default: _UnknownErrorModal2.default
}, _defineProperty(_ERROR_MODALS_MAP, _errorConstants.BOARD_ERROR.GENERIC_ERROR, _UnknownErrorModal2.default), _defineProperty(_ERROR_MODALS_MAP, _errorConstants.BOARD_ERROR.DELETED, _BoardSimpleErrorModal2.default), _defineProperty(_ERROR_MODALS_MAP, _errorConstants.BOARD_ERROR.NOT_FOUND, _BoardSimpleErrorModal2.default), _defineProperty(_ERROR_MODALS_MAP, 'credentials_required', _BoardAccessDeniedModal2.default), _defineProperty(_ERROR_MODALS_MAP, _errorConstants.BOARD_ERROR.ACCESS_DENIED, _BoardAccessDeniedModal2.default), _defineProperty(_ERROR_MODALS_MAP, _errorConstants.BOARD_ERROR.TIMEOUT, _TimeoutErrorModal2.default), _defineProperty(_ERROR_MODALS_MAP, _errorConstants.BOARD_ERROR.CONNECTION_LOST, _TimeoutErrorModal2.default), _ERROR_MODALS_MAP);

var isNetworkError = function isNetworkError(errorDetails) {
    return errorDetails && (errorDetails.code === _errorConstants.BOARD_ERROR.TIMEOUT || errorDetails.code === _errorConstants.BOARD_ERROR.CONNECTION_LOST);
};

var getBoardPermissionsError = function getBoardPermissionsError(elements, currentBoardId, currentUserId) {
    var accessDenied = (0, _permissionsService.confirmedInvalidPermissions)(elements, currentBoardId, currentUserId, READ_PERMISSIONS);
    if (!accessDenied) return null;

    return Immutable.fromJS({
        code: _errorConstants.BOARD_ERROR.ACCESS_DENIED,
        message: "You don't have access to this board"
    });
};

var workspaceErrorSelector = (0, _reselect.createSelector)(function (state) {
    return state.get('elements');
}, function (state, ownProps) {
    return ownProps.currentBoardId;
}, function (state) {
    return state.getIn(['app', 'currentUser', '_id']);
}, function (state, ownProps) {
    return state.getIn(['app', 'currentUser']);
}, _boardSelector.getCurrentBoardError, _boardSelector.getIsCurrentBoardFetched, _errorModalSelector.getActiveErrorModalId, _errorModalSelector.getErrorModalData, function (elements, currentBoardId, currentUserId, currentUser, currentBoardError, isCurrentBoardFetched, activeErrorModalId, errorModalData) {
    return {
        permissionsError: getBoardPermissionsError(elements, currentBoardId, currentUserId),
        currentUser: currentUser,
        currentBoardError: currentBoardError,
        isCurrentBoardFetched: isCurrentBoardFetched,
        activeErrorModalId: activeErrorModalId,
        errorModalData: errorModalData
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        navigateToLogin: function navigateToLogin() {
            return dispatch((0, _navigationActions.navigateToLogin)());
        },
        dispatchModalOpen: function dispatchModalOpen(_ref) {
            var modalId = _ref.modalId,
                data = _ref.data;
            return dispatch((0, _errorModalActions.errorModalOpen)({ modalId: modalId, data: data }));
        },
        dispatchModalClose: function dispatchModalClose() {
            return dispatch((0, _errorModalActions.errorModalClose)());
        },
        dispatchCurrentBoardIdSet: function dispatchCurrentBoardIdSet(_ref2) {
            var boardId = _ref2.boardId;
            return dispatch((0, _currentBoardIdActions.currentBoardIdSet)({ boardId: boardId }));
        }
    };
};

var WorkspaceErrorModalManager = (_dec = (0, _reactRedux.connect)(workspaceErrorSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(WorkspaceErrorModalManager, _React$Component);

    function WorkspaceErrorModalManager() {
        var _ref3;

        var _temp, _this, _ret;

        _classCallCheck(this, WorkspaceErrorModalManager);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = WorkspaceErrorModalManager.__proto__ || Object.getPrototypeOf(WorkspaceErrorModalManager)).call.apply(_ref3, [this].concat(args))), _this), _this.getErrorFromProps = function (props) {
            return props.currentBoardError || props.permissionsError;
        }, _this.getWorkspaceError = function (props) {
            var isCurrentBoardFetched = props.isCurrentBoardFetched,
                dispatchModalOpen = props.dispatchModalOpen,
                currentBoardId = props.currentBoardId;
            // If we don't have the board then we need to wait for it before displaying an error

            if (!isCurrentBoardFetched) return null;
            var error = _this.getErrorFromProps(props);
            if (!error) return null;
            var modalId = error.get('code') || _errorConstants.BOARD_ERROR.GENERIC_ERROR;
            dispatchModalOpen({ modalId: modalId, data: { error: error.toJS(), boardId: currentBoardId } });
            _this.viewPreviousOrRootBoard(props, error);
            return error;
        }, _this.viewPreviousOrRootBoard = function (_ref4, errorDetails) {
            var currentBoardId = _ref4.currentBoardId,
                currentUser = _ref4.currentUser,
                dispatchCurrentBoardIdSet = _ref4.dispatchCurrentBoardIdSet;

            var rootBoardId = currentUser.get('rootBoardId');
            var isGuest = currentUser.get('isGuest');

            // TODO Change this logic if we instead navigate to the previous board
            if (isGuest) return;

            var details = errorDetails.toJS();
            if (currentBoardId !== rootBoardId) {
                return dispatchCurrentBoardIdSet({ boardId: rootBoardId });
            }

            // Is root board and is not network error
            if (!isNetworkError(details)) {
                var errorMessage = 'The root board has an error, this cannot be recovered from.';
                var error = { id: details.id, rootBoardId: rootBoardId, errorMessage: errorMessage, details: details };
                (0, _rollbarService.manuallyReportError)({ errorMessage: errorMessage, error: error, sensitive: false, level: _rollbarConstants.ROLLBAR_LEVELS.CRITICAL });
                console.error(errorMessage, rootBoardId, errorDetails);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WorkspaceErrorModalManager, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.getErrorFromProps(this.props)) this.getWorkspaceError(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var location = nextProps.location,
                permissionsError = nextProps.permissionsError,
                currentUser = nextProps.currentUser,
                dispatchModalClose = nextProps.dispatchModalClose,
                activeErrorModalId = nextProps.activeErrorModalId;

            // A guest user has a permissions error, so just redirect them to login instead of

            if (permissionsError && currentUser && currentUser.get('isGuest')) {
                nextProps.navigateToLogin();
            }

            // If there's an error modal active, close it on route change
            if (activeErrorModalId && location.pathname !== this.props.location.pathname) {
                dispatchModalClose();
            }

            // Only attempt to open the modal if there is a new error, this should prevent infinite recursions
            if (this.getErrorFromProps(this.props) !== this.getErrorFromProps(nextProps)) {
                this.getWorkspaceError(nextProps);
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            if (this.props.permissionsError !== nextProps.permissionsError) return true;

            return nextProps.activeErrorModalId !== this.props.activeErrorModalId;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var _props = this.props,
                activeErrorModalId = _props.activeErrorModalId,
                dispatchModalClose = _props.dispatchModalClose;

            if (activeErrorModalId) dispatchModalClose();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                activeErrorModalId = _props2.activeErrorModalId,
                errorModalData = _props2.errorModalData,
                dispatchModalClose = _props2.dispatchModalClose;


            var modalComponent = null;

            if (activeErrorModalId) {
                var ActiveModal = ERROR_MODALS_MAP[activeErrorModalId] || ERROR_MODALS_MAP.default;
                modalComponent = _react2.default.createElement(ActiveModal, _extends({}, errorModalData.toJS(), this.props));
            }

            return _react2.default.createElement(
                _ModalManager2.default,
                { dispatchModalClose: dispatchModalClose },
                modalComponent
            );
        }
    }]);

    return WorkspaceErrorModalManager;
}(_react2.default.Component)) || _class);


WorkspaceErrorModalManager.propTypes = {
    permissionsError: _propTypes2.default.object,
    currentBoardId: _propTypes2.default.string,
    navigateToLogin: _propTypes2.default.func,
    currentBoardError: _propTypes2.default.func,
    isCurrentBoardFetched: _propTypes2.default.bool,
    activeErrorModalId: _propTypes2.default.string,
    dispatchModalOpen: _propTypes2.default.func,
    dispatchModalClose: _propTypes2.default.func,
    dispatchCurrentBoardIdSet: _propTypes2.default.func,
    location: _propTypes2.default.object.isRequired,
    errorModalData: _propTypes2.default.object
};

exports.default = WorkspaceErrorModalManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/WorkspaceErrorModalManager.js
// module id = 1758
// module chunks = 0